// extracted by mini-css-extract-plugin
module.exports = {"bodyContent":"BodyContent_bodyContent__S_VZA"};